import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class RightDrawerGuard  {
  constructor(
    private router: Router,
  ){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) {
    if(!next.children.some(({outlet}) => outlet === 'rightDrawer')) {
      return this.router.parseUrl(`${state.url}/(rightDrawer:comments)`)
    }
    return true
  }
}
